import { Swiper, SwiperClass, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import { Slide } from './Slide';
import { Autoplay, Pagination } from 'swiper/modules';
import { useState } from 'react';
import clsx from 'clsx';

const slides = [1, 2, 3];

export const MobileSlider = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const handleSlideChange = (swiper: SwiperClass) => {
    setActiveIndex(swiper.activeIndex);
  };

  return (
    <div>
      <Swiper
        modules={[Autoplay, Pagination]}
        spaceBetween={20}
        slidesPerView={1}
        onSlideChange={handleSlideChange}
        autoplay={{ delay: 3000 }}
      >
        {slides.map(slide => (
          <SwiperSlide
            key={slide}
            className="!flex items-center justify-center"
          >
            <Slide slideName={`mobile_${slide}.webp`} />
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="overflow-hidde mt-3 flex justify-center gap-2">
        {slides.map((_, index) => (
          <div className="bg-card h-[3px] w-[67px] rounded">
            <div
              key={index}
              className={clsx(
                'h-full rounded',
                activeIndex === index && 'animate-progress bg-white',
                activeIndex > index && 'bg-white'
              )}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
